<div class="effective-views-card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <mat-icon class="cursor-pointer me-2" (click)="collapsed = !collapsed">
        {{ collapsed ? 'chevron_right' : 'expand_more' }}
      </mat-icon>
      <strong>Effective Views (Used in Optimization)</strong>
    </div>
    <button mat-flat-button color="primary"
            class="rounded-pill"
            (click)="generate.emit()"
            [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="18" class="d-inline-block me-1"></mat-spinner>
      Generate Payload
    </button>
  </div>

  <div class="card-body" *ngIf="!collapsed">
    <div *ngIf="error" class="alert alert-danger mt-2">
      {{ error }}
    </div>

    <table class="table" *ngIf="payload?.length && !error">
      <thead>
        <tr>
          <td>Object</td>
          <td>Source</td>
          <td class="text-end">Effective Value</td>
          
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of payload">
          <td>{{ item.resolvedName || item.type }}</td>
          <td class="text-capitalize">{{ item.source_level }}</td>
          <td class="text-end number-col">{{ item.value * 100 | number:'1.0-2' }}%</td>
        </tr>
      </tbody>
    </table>

    <p *ngIf="!payload?.length && !error && !loading" class="text-muted text-center py-3">
      Click "Generate Payload" to merge views from all levels.
    </p>

    <div *ngIf="payload?.length && !error" class="text-end mt-3">
      <button mat-flat-button color="accent"
              class="rounded-pill"
              (click)="optimize.emit()">
        Optimise
      </button>
    </div>
  </div>
</div>
